import { CustomerFieldsConfig } from "app/back-office/shared/models/customer/customer.model";

export class TenantDTO {
  id: string;
  name: string;
  settings?: TenantSettingsDTO[];
  constructor(init?: TenantDTO) {
    Object.assign(this, init);
  }
}

export class TenantSettingsDTO{
  id: number;
  name: string;
  tenantId: string;
  type: TenantSettingType;
  value: any;
  valueType: TenantSettingValueType; //mi dice di che tipo è il value
  constructor(init?: TenantSettingsDTO) {
    Object.assign(this, init);
  }
}

export class TenantVM extends TenantDTO {
  checked: boolean;
  constructor(init?: TenantDTO) {
    super();
    Object.assign(this, init);
  }
}

export enum TenantSettingType {
  ShowItalianInvoicingData = 1,
  ShowPosLimits = 2,
  ShowPosAlternativeVat = 3,
  EnabledCustomerFields = 4,
  EnabledOrdesBulkOperations= 5
}

export enum TenantSettingValueType {
    String = 1,
    Boolean = 2,
    Integer = 3,
    Long = 4,
    Decimal = 5,
    Json = 6
}